import { clsx } from 'clsx'

import type { TagPillProps } from './TagPill.types'

export const TagPill = (props: TagPillProps) => {
  const { children, className, style } = props

  return (
    <span className={clsx('TagPill', className)} style={style}>
      {children}
    </span>
  )
}

